import React, { Component } from 'react';
import { Container, Card, Form, Button, Modal } from 'react-bootstrap';
import axios from 'axios'
import { withRouter } from 'react-router-dom';
import Upload from '../../containers/Upload/Upload';
import Footers from '../../component/Footers/Footer';
import DatePicker from "react-datepicker";
import { format, subYears } from 'date-fns';
import Loader from '../../component/Loader/Loader'
import Headers from '../../component/Headers/Headers';
import ReCAPTCHA from "react-google-recaptcha";
import { confirmAlert } from 'react-confirm-alert'; // Import

import "react-datepicker/dist/react-datepicker.css";
import ErrorModal from '../../component/ErrorModal/ErrorModal';

const sitekey = process.env.REACT_APP_SITEKEY

class Login extends Component {

     
    constructor(props) {
        super(props)
        this.recaptchaRef = React.createRef();
    }

    state = {
        validated: false,
        setValidated: false,
        StudentID: '',
        DOB: '',
        Email: '',
        isValidRecaptcha: false,
        SiteKey: '',

    }

    //Datepicker onChange
    handleChange = date => {
        this.setState({
            DOB: date
        });
    };

    //Validation
    submitHandler = (e) => {
        const form = e.currentTarget;

        //const isValidChar = /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/.test(this.state.Email)
        const isValidChar = /(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})+$/.test(this.state.Email)
        let isValidDate = false;

        if (this.state.DOB) {
            isValidDate = /^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/]\d{4}$/.test(format(this.state.DOB, "dd/MM/yyyy"))
        }

        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();

            this.setState({
                errorMsg: 'All fields are required',
                show: true
            })
        } else if (!isValidChar) {
            e.preventDefault();
            e.stopPropagation();
            this.setState({
                errorMsg: 'Invalid Email',
                show: true
            })
        } else if (!isValidDate) {
            e.preventDefault();
            e.stopPropagation();
            this.setState({
                errorMsg: 'Invalid Date',
                show: true
            })
        } else {
            this.setState({ setValidated: true, isLoading: true });

            const studentInfo = {
                StudentID: this.state.StudentID,
                DOB: format(this.state.DOB, "dd/MM/yyyy"),
                Email: this.state.Email,
                //isValidRecaptcha:this.state.isValidRecaptcha,
                token:this.recaptchaRef.current.getValue()
            }


            e.preventDefault();
            const url = process.env.REACT_APP_VALIDATESTUDENTINFO
            //console.log(studentInfo)
            //console.log(sitekey)
            axios.post(url, studentInfo)
                .then((response) => {
                    const result = response.data;
                    //console.log(result)
                    //console.log("remarks "+result.validationRemarks)
                    if (result.isValidStudent) {
                        this.setState({ isLoading: false });

                        //Remove Azure token if any when successful login via new student detail
                        localStorage.clear();

                        this.props.history.push({
                            pathname: '/PhotoGuide',
                            state: {
                                accesstoken: result.accessToken,
                                studentID: this.state.StudentID,
                                userType: 'Student'
                            }
                        })
                    } 
                    else if (result.validationRemarks==="Invalid captcha")
                    //else if (!result.isValidRecaptcha)
                    {
                        this.setState({
                            isLoading: false,
                            show: true,
                            errorMsg: 'Please try again with valid captcha'
                        })
                    }
                    else {
                        this.setState({
                            isLoading: false,
                            show: true,
                            errorMsg: 'Please try again with valid student information'
                        })
                    }
                })
                .catch((error) => {
                    console.log(error)
                    if (error.response) {
                        this.setState({
                            isLoading: false,
                            show: true,
                            errorMsg: error.response.status + ' ' + error.response.statusText
                        })
                    } else {
                        this.setState({
                            isLoading: false,
                            show: true,
                            errorMsg: error.message
                        })
                    }
                    // this.props.history.push({
                    //     pathname: '/Upload',
                    //     state: {
                    //         accesstoken: 'Student',
                    //         studentID: this.state.StudentID,
                    //         userType: 'Student'
                    //     }
                    // })
                });
        }
    }

    changeHandler = (e) => {
        const target = e.target;
        const name = target.name;

        if (name === "StudentID") {
            //const isValidChar = !/^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/.test(e.target.value)
            const isValidChar = !/(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})+$/.test(this.state.Email)
            if (isValidChar && e.target.value.length <= 20) {
                this.setState({ StudentID: e.target.value });
            }
        }

        if (name === "Email") {
            this.setState({ Email: e.target.value });
        }
    }

    recaptchaHandler = value => {
        //console.log("Captcha value:", value);
        //const captchaRes=value
        console.log("token"+ this.recaptchaRef.current.getValue())
        //console.log("captchaRes:", captchaRes);
       
        if (value) {
            this.setState({ isValidRecaptcha: true ,token1:value});
        } else {
            this.setState({ isValidRecaptcha: false })
        }
        // if value is null recaptcha expired
        if (value === null) {
            this.setState({ isValidRecaptcha: false })
        }
        //console.log("isValidRecaptcha: ",this.state.isValidRecaptcha);
    }
    closeHandler = () => {
        this.setState({ show: false })
    }

    render() {
        return (
            <div>
                <Headers />
                <Container className="col-md-6">
                    {this.state.isLoading ? <Loader isLoading={this.state.isLoading} /> : null}
                    <Card className="mt-5">
                        <Card.Header className="bg-brandcolor text-center">
                            <h5 className="text-white">Student Information</h5>
                        </Card.Header>
                        <Card.Body>
                            <Form className={this.state.validate} noValidate validated={this.state.validated} onSubmit={(event) => { this.submitHandler(event) }}>
                                <Form.Group controlId="validationCustom01">
                                    <Form.Label className="text-success"><b>Student ID:</b></Form.Label>
                                    <Form.Label className="text-danger"><b>*</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="StudentID"
                                        required
                                        max="20"
                                        value={this.state.StudentID}
                                        onChange={(event) => { this.changeHandler(event) }}
                                    />
                                    {/* <Form.Control.Feedback type="invalid">{this.state.validationMsg}</Form.Control.Feedback>                               */}
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label className="text-success"><b>Date Of Birth:</b></Form.Label>
                                    <Form.Label className="text-danger"><b>*</b></Form.Label>
                                    <DatePicker
                                        className="form-control"
                                        selected={this.state.DOB}
                                        onChange={this.handleChange}
                                        dateFormat="dd/MM/yyyy"
                                        maxDate={subYears(new Date(), 15)}
                                        placeholderText="dd/MM/yyyy"
                                        showYearDropdown
                                        yearDropdownItemNumber={15}
                                        scrollableYearDropdown
                                    />
                                </Form.Group>
                                <Form.Group controlId="validationCustom03">
                                    <Form.Label className="text-success"><b>Email:</b></Form.Label>
                                    <Form.Label className="text-danger"><b>*</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="Email"
                                        required
                                        value={this.state.Email}
                                        onChange={(event) => { this.changeHandler(event) }}
                                    />
                                    {/* <Form.Control.Feedback type="invalid">{this.state.validationMsg}</Form.Control.Feedback>                               */}
                                </Form.Group>
                                {<ReCAPTCHA
                                    ref={this.recaptchaRef}
                                    sitekey={sitekey}
                                    onChange={this.recaptchaHandler}
                                /> }
                                <Form.Group>
                                    {/* <input type="submit" className="btn btn-success btn-lg w-100 mt-3" value="Submit" disabled={!this.state.isValidRecaptcha} /> */}
                                    <input type="submit" className="btn btn-success btn-lg w-100 mt-3" value="Submit" disabled={!this.state.isValidRecaptcha}/>
                                </Form.Group>
                            </Form>

                        </Card.Body>
                    </Card>

                </Container>
                <ErrorModal msg={this.state.errorMsg} show={this.state.show} click={() => this.closeHandler()} />
                <Footers />
            </div>

        );
    }

}

export default withRouter(Login);